import React from 'react'
import PropTypes from 'prop-types'
import { cx } from 'react-emotion'

import fractalSecurityImage from '../../assets/img/security.png'
// import fractalLogoImage from '../../assets/img/fractal_logo.svg'
// import horizontalFractalLogoImage from '../../assets/logo/fractal-horizontal.svg'

import {
  fractalLogo,
  responsive as responsiveLogo
} from './styles/LogoImage.style'

const LogoImage = ({ horizontal, responsive }) => (
  <img
    className={cx([
      fractalLogo,
      responsive ? responsiveLogo : false
    ].filter(Boolean))}
    src={fractalSecurityImage}
    alt='Fractal Id'
  />
)

LogoImage.propTypes = {
  horizontal: PropTypes.bool,
  responsive: PropTypes.bool
}

LogoImage.defaultProps = {
  horizontal: false,
  responsive: false
}

export default LogoImage
